import React from 'react';
import { ToastContainer, Slide } from 'react-toastify';

const Notifications = () => <ToastContainer autoClose={2500} transition={Slide} />;

export default Notifications;
